import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {PropertyGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {BindGroupName} from '@mintdata/mint-kit/api/decorators/Editor';
import {BoxId} from '@mintdata/mint-kit/api/models/Identifiers';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {serialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

export type BindGroupItemId = string

const MIGRATED_VERSION:DesignerVersion = 1;

function combineFieldPaths(fieldPath1:FieldPath, fieldPath2:FieldPath):FieldPath
{
    if( fieldPath1 === '.' && fieldPath2 !== '.' )
        return fieldPath2;

    return [
        fieldPath1 !== '.' ? fieldPath1 : '',
        fieldPath2 !== '.' ? fieldPath2 : ''
    ].join('.');
}

function getFullPath(bindTemplate:any):FieldPath
{
    return bindTemplate.parent
        ? combineFieldPaths(bindTemplate.parent.getFullPath(), bindTemplate.path)
        : bindTemplate.path;
}

export function createBindItemByTemplate(bindTemplate:any, pathValue:any, parent:BindGroupItemId):any
{
    const bindItem:any = {
        id: IdUtil.newGUID(),
        path: bindTemplate.path,
        parent,
        templatePath: getFullPath(bindTemplate),
        state: {
            prevValue: null,
            userInput: null,
            isValid: true,
            validationError: null,
            isSelected: false,
            isFocused: false
        },
        paths: null,
        bindingId: null
    };

    if( bindTemplate.paths.size > 0 )
    {
        const itemsCount:number = bindTemplate.isArray
            ? pathValue
                ? pathValue.length
                : 0
            : 1;

        for( let index = 0; index < itemsCount; index++ )
        {
            addArrayBindItemByTemplate(
                bindItem,
                bindTemplate,
                index,
                bindTemplate.isArray
                    ? pathValue[index]
                    : pathValue,
            );
        }
    }

    return bindItem;
}

export function createBindItemSnapshot(propName:string, parent:BindGroupItemId):any
{
    return {
        id: IdUtil.newGUID(),
        path: propName,
        parent,
        templatePath: propName,
        state: {
            userInput: null,
        },
        paths: null,
        bindingId: null,
    };
}

export function addArrayBindItemByTemplate(bindItem:any, bindTemplate:any, index:number, itemPathValue:any):void
{
    const pathsSnapshot:any = {};

    if( !bindItem.paths )
        bindItem.paths = [];

    bindTemplate.paths.forEach((childBindTemplate:any, fieldPath:FieldPath) =>
    {
        const childBindGroupItem:any = createBindItemByTemplate(
            childBindTemplate,
            itemPathValue && itemPathValue[fieldPath],
            bindItem.id
        );

        pathsSnapshot[childBindGroupItem.id] = childBindGroupItem;
    });

    bindItem.paths.splice(index, 0, pathsSnapshot);
}

function createBindGroup(bindGroupName:BindGroupName,
                         prop:any,
                         propValue:any):any
{
    const rootBindItemTemplate:any = prop.bindGroupsTemplates.get(bindGroupName);

    const rootBindItem:any = createBindItemByTemplate(
        rootBindItemTemplate,
        propValue,
        null
    );

    return {
        id: IdUtil.newGUID(),
        name: bindGroupName,
        rootBindItem
    };
}

export function createProp(boxId:BoxId,
                           visualComponentId:string,
                           prop:any,
                           group:any):any
{
    const propSnapshot:any = {
        id: IdUtil.newGUID(),
        name: prop.name,
        group,
        boxId,
        visualComponentId,
        _bindGroups: {},
        _value: prop.defaultValue
            ? serialize(prop.defaultValue)
            : null
    };

    if( prop.editorConfig && prop.editorConfig.bindGroups )
    {
        // for( const bindGroupName of Object.keys(prop.editorConfig.bindGroups) )
        // {
        //     let bindGroupConfig:any = prop.editorConfig.bindGroups[bindGroupName];
        //
        //     if( bindGroupConfig )
        //     {
        //         const bindGroup:any = createBindGroup(
        //             bindGroupName,
        //             prop,
        //             prop.defaultValue
        //         );
        //
        //         propSnapshot._bindGroups[bindGroup.id] = bindGroup;
        //     }
        // }
    }

    return propSnapshot;
}

export const migration_0_1:IMigration = {
    from: 0,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(!designState.designerVersion);

        console.log('migration 0->1 designState', designState);

        if( designState.surface && designState.surface.artboard && designState.surface.artboard.allBoxes )
            Object.values(designState.surface.artboard.allBoxes).forEach((boxSnapshot:any) =>
            {
                const {componentDesc} = boxSnapshot;
                const visibilityPropSnapshot:any = createProp(
                    componentDesc.boxId,
                    componentDesc.visualComponentId,
                    SystemPropsConfigs.basePropertiesConfigs.get(SystemPropsConfigs.VISIBILITY_PROP_NAME),
                    PropertyGroup.Base
                );

                componentDesc._baseProperties[visibilityPropSnapshot.id] = visibilityPropSnapshot;
            });

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
